import { filterErrors as a } from "./index347.mjs";
import { getPath as b } from "./index357.mjs";
function s(t) {
  const r = a(t);
  return { hasErrors: Object.keys(r).length > 0, errors: r };
}
function i(t, r, u = "", c = {}) {
  return typeof t != "object" || t === null ? c : Object.keys(t).reduce((f, y) => {
    const e = t[y], o = `${u === "" ? "" : `${u}.`}${y}`, n = b(o, r);
    let l = !1;
    return typeof e == "function" && (f[o] = e(n, r, o)), typeof e == "object" && Array.isArray(n) && (l = !0, n.forEach((j, p) => i(e, r, `${o}.${p}`, f))), typeof e == "object" && typeof n == "object" && n !== null && (l || i(e, r, o, f)), f;
  }, c);
}
function $(t, r) {
  return s(typeof t == "function" ? t(r) : i(t, r));
}
export {
  $ as validateValues
};
